import {Component} from '@angular/core';

@Component({
  selector: 'mz-sidenav-subheader',
  templateUrl: './sidenav-subheader.component.html',
  styleUrls: ['./sidenav-subheader.component.scss'],
})
export class MzSidenavSubheaderComponent {
}
